import { useState,useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/global/modal";
import ModalHeader from "components/global/modal-header";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";
import toast from "react-hot-toast";
import DateInput from "components/input-group/date-input";

export default function DateEdit({
  hide,
  userData,
  profile,
  milestone,
}){
    const {t} = useTranslation();
    const [submitLoading, setSubmitLoading] = useState(false);
    const [errorMessages,seterrorMessages] = useState()

    const [startDate, setStartDate] = useState({
        day: null,
        month: null,
        year: null,
        approximately: false,
      });
      const [endDate, setEndDate] = useState({
        day: null,
        month: null,
        year: null,
        approximately: false,
        present: false,
      });
    

    useEffect(()=>{
        let startDate = {
        day: milestone.start_day,
        month: milestone.start_month,
        year: milestone.start_year,
        approximately: milestone.is_start_date_approximately ? true : false,
        };

        let endDate = {
        day: milestone.end_day,
        month: milestone.end_month,
        year: milestone.end_year,
        present: milestone.is_present ? true : false,
        approximately: milestone.is_end_date_approximately ? true : false,
        };
        setStartDate((prev) => ({
            ...prev,
            ...startDate,
        }));
        setEndDate((prev) => ({
            ...prev,
            ...endDate,
        }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[milestone])

    const submit = async()=>{
        try {
            setSubmitLoading(true);
            let date = {
                end_day:endDate.day,
                end_month:endDate.month,
                end_year:endDate.year,
                start_day:startDate.day,
                start_month:startDate.month,
                start_year:startDate.year,
                present: endDate.present,
                is_present: endDate.present,
                is_end_date_approximately:endDate.approximately,
                is_start_date_approximately:startDate.approximately

            }
            hide({ success: true, startDate, endDate,date });
        } catch (err) {
            console.log("error@submit", err);
            const { data, status } = err;
            if (status === 422) {
                seterrorMessages(data.errors)
            }
            toast.error(
                status === 422 ? data?.message : t('somethingWentWrong')
            );
            setSubmitLoading(false);
        } finally {
            setSubmitLoading(false);
        }
    }

    return (
        <Modal
            width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible" 
        >
            <div className="w-full relative">
                <ModalHeader
                    title={t("dateRange")}
                    hide={hide}
                    showPopInfo
                    popInfoType="add_milestone"
                    padding = "pl-4 pr-7 py-3.5"
                    />
                <div className="w-full grid 1smd:grid-cols-2 1smd:gap-7 pl-6 pr-4">
                    <DateInput
                        label={t('start')}
                        name="startDate"
                        showApp={true}
                        date={startDate}
                        setDate={setStartDate}
                        errors={errorMessages}
                        fieldKey="start_date"
                        required={true}
                        isClearable={true}
                    />
                    <DateInput
                        label={t('end')}
                        name="endDate"
                        showApp={true}
                        showPresent={true}
                        date={endDate}
                        setDate={setEndDate}
                        errors={errorMessages}
                        fieldKey="end_date"
                        isClearable={true}
                    />
                </div>
                <div className="border-t border-gray py-4 px-4">
                    <div className="w-full flex items-center justify-end 1sm:justify-end space-x-2">
                        <Button
                            buttonName={t('cancel')}
                            buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7rem]"
                            buttonTextClass="text-black text-sm font-semibold"
                            onClick={() => hide()}
                            disabled={submitLoading}
                        />
                        <Button
                            disabled={!startDate?.year}
                            key="save-btn-category"
                            buttonName={t('save')}
                            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
                            buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                            onClick={submit}
                            loadingIcon={
                            submitLoading ? (
                                <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                            ) : null
                            }
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}